var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AlertCard',{attrs:{"icon":"error_outline","text":_vm.$t('errors.loading.description'),"subtext":_vm.$t('errors.loading.suggestion')}})}
var staticRenderFns = []

export { render, staticRenderFns }